// extracted by mini-css-extract-plugin
export default {"switch":"_33zqX"};